import { MobileKeyboardElement } from "./mobile-keyboard/MobileKeyboardElement";
import { ReminderUIElement } from "./reminder/ReminderUIElement";

export class Apps
{
  static applyOnDocument()
  {
    ReminderUIElement.applyOnDocument();
    MobileKeyboardElement.applyOnDocument();
  }
}